import _defineProperty from "@babel/runtime/helpers/defineProperty";
class ExperimentsStore {
  constructor() {
    _defineProperty(this, "experiments", {});
  }
  get() {
    return this.experiments;
  }
  set(experiments) {
    this.experiments = experiments;
  }
}
const isEnabled = experiment => () => getExperiments()[experiment] === 'true';
export const experimentsStore = new ExperimentsStore();
export const getExperiments = () => experimentsStore.get();
export const isV3ToV2MappingAPIEnabled = isEnabled('specs.vod.v3ToV2Mapping');
export const isPrivateGraphAPIEnabled = isEnabled('specs.vod.useGraphAPI');
export const isWixCodeSEOEnabled = () => isEnabled('specs.vod.wixCodeSEO')() && isV3ToV2MappingAPIEnabled();
//# sourceMappingURL=experiments.js.map